import { Language, SectionSchema, Shape, TranslationSchema } from '@/types'

export interface SectionOption {
  label: string
  value: string
  sectionShapesId: string
  shapeSubShapesId?: string
}

type SectionAdapterResult = {
  label: string
  value: string
  options: SectionOption[]
  translations?: {
    items: TranslationSchema[]
  }
}

export const sectionAdapter = (
  section: SectionSchema,
  lang?: Language,
): SectionAdapterResult => {
  // Create options array including the section itself and its shapes
  const options: SectionOption[] = section.shapes.items.map((shape: Shape) => ({
    label: shape.name.trim(),
    value: shape.id,
    sectionShapesId: section.id,
    // Form selections use shapeSubShapesId to create a child shape under this option.
    shapeSubShapesId: shape.id,
  }))

  // Sort the options array
  options.sort(sortOptionsByLabel)

  const label = lang ? checkForTranslation(section, lang) : section.name

  return {
    label,
    value: section.id,
    translations: section.translations,
    options: [
      {
        label,
        value: section.id,
        sectionShapesId: section.id,
      },
      ...options,
    ],
  }
}

export const sortOptionsByLabel = (
  a: { label: string },
  b: { label: string },
) => a.label.localeCompare(b.label)

const checkForTranslation = (section: SectionSchema, lang: Language) => {
  const translation = section.translations?.items.find(
    (translation) => translation.lang === lang,
  )
  return translation ? translation.label : section.name
}
